<template>
    <div id="meetingForm"><br>
      <h2 v-if="mode=='update'">Edit Meeting</h2>
      <h2 v-else>New Meeting</h2>
      <b-form style="margin-top:1.5rem">

        <b-form-group id="meetingTitleGroup" label="Meeting name *" lable-for="meetingName" >
          <b-form-input type="text" id="meetingName" placeholder="What is the meeting called?" v-model="meeting.name" style="width:32rem" autofocus :state="meetingNameValid" Xaria-describedby="inputLiveFeedback"></b-form-input>
          <b-form-invalid-feedback id="inputLiveFeedback">Enter the meeting name.</b-form-invalid-feedback>
        </b-form-group>
        <br />
        <!-- <b-form-group id="meetingPurposeGroup" label="Purpose" lable-for="meetingPurpose" >
          <b-form-input type="text" placeholder="What do you want to achieve?" id="meetingPurpose" v-model="meeting.purpose" style="width:32rem" ></b-form-input>
        </b-form-group> -->

        <!-- <MeetingTime :date="new Date(meeting.date)" :time="meeting.time" :duration="meeting.duration"></meetingTime> -->
        <MeetingTime :meeting="meeting" @dateChanged="meeting.date=$moment($event).format('YYYY/MM/DD')" @timeChanged="meeting.time=$event" @durationChanged="meeting.duration=$event"></meetingTime>

        <!-- <b-container style="width: 32rem; margin:0; padding:0">
          <b-row Xno-gutters>
            <b-col cols="6">Date<br />
              <v-date-picker v-model="date" :attributes="calAttributes" :masks="{input:'WWWW  DD-MMM-YYYY'}"/>
            </b-col>
            <b-col cols="3">
              Start<br>
              <multiselect id="startTime" ref="startTime" v-model="startTime" :options="startTimes" :show-labels="false" :searchable="false"  @open="selectTime('startTime')">
              </multiselect>

            </b-col>
            <b-col cols="3">
              End
              <multiselect ref="endTime" v-model="endTime" :options="startTimes" :show-labels="false" :searchable="false"  @open="selectTime('endTime')">
              </multiselect>
          </b-col>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6"></b-col>
            <b-col cols="6" style="color:#808080; line-height: 2rem">
              <span style="margin-left:0.2rem">Duration: {{ dispDuration }}</span><br />
            </b-col></b-row>
        </b-container> -->

        <b-form-group id="meetingTitleGroup" label="Attendees" lable-for="meetingName" v-if="mode == 'create'" style="margin-top:2rem">

          <vue-tags-input v-if="googleContactsConnected"
            v-model="tag"
            :tags="selectedAttendees"
            @tags-changed="newTags => selectedAttendees = newTags"
            placeholder="Enter or copy and paste email addresses"
            autocomplete="no"
            :autocomplete-items="filteredItems"
            @before-adding-tag="beforeAddTag"
            data-hj-suppress
             />

          <vue-tags-input v-if="!googleContactsConnected"
            v-model="tag"
            :tags="selectedAttendees"
            @tags-changed="newTags => selectedAttendees = newTags"
            placeholder="Enter or copy and paste email addresses"
            autocomplete="no"
            @before-adding-tag="beforeAddTag"
            data-hj-suppress
          />
          <div style="display:block !important" class="invalid-feedback" v-if="(attendeeEmailValid ===false)  && validationOn">
            Some attendees have invalid emails
          </div>

          <b-button v-if="!googleContactsConnected" size="sm" style="margin-top:0.5rem; max-Height:2.3rem ;border-color:var(--primaryColor1);color:var(--primaryColor1);margin-left:14rem"  @click="requestContactsAccess" variant="outline-primary">
            <img src="@/assets/g-normal.png" Style="max-width:1.8rem">
            Connect Google Calendar & Contacts
          </b-button>&nbsp;&nbsp;

        </b-form-group>

        <b-button id="showMeetingLink" v-if="!showMeetingLink && !meeting.meetingLink" variant="link" style="font-size: 1rem; color: #808080; margin: 0; padding: 0" @click="showMeetingLink=true">+ Add Meeting Link</b-button>
        <b-form-input id="meetingLink" v-if="showMeetingLink || meeting.meetingLink" placeholder="Paste meeting URL here" v-model.trim="meeting.meetingLink" style="width:32rem;margin-top:0.5rem" size="sm"></b-form-input>

        <br>
        <div class="formButtons">
          <b-button variant="secondary" @click="cancel">Cancel</b-button>&nbsp;&nbsp;
          <b-button v-if="mode == 'create'" variant="primary" @click="saveMeeting()">Get Started</b-button>
          <b-button v-if="mode == 'update'" variant="primary" @click="saveMeeting()">Save</b-button>
        </div>
      </b-form>

    </div>
</template>
<script>
import {firebase, db, router } from '../main'
import MeetingTime from './MeetingTime.vue'
export default {
  name: 'EditMeeting',
  props: ['user'],
  data () {
    return {
      showMeetingLink: false,
      attendeesValid: true,
      tag: '',
      tags: [],
      pastingContacts: false,
      googleUser: '',
      googleOptions: '',
      googleContactsConnected: true,
      selectedAttendees: [{email: this.user.email, text:this.user.displayName}],
      // date: '',
      reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      // validateAttendees : [
      //   {
      //   classes: 'email',
      //   rule: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      //   disableAdd: false
      //   }
      // ],
      attendees:  [],
      id: '',
      mode: '',
      startTime: '10:00',
      endTime: '11:00',
      meeting: {name: '',date:this.$moment().add(24, 'hours').format('YYYY/MM/DD'),  time: '10:00', owner: this.user.uid, duration: '60'},
      // formValid:true,
      validationOn: false,
      // calAttributes: [{
      //      key: 'today',
      //      dot: true,
      //      dates: new Date(),
      //   }],
      durations: [{min:'15',label:'00:15'},{min:'30',label:'00:30'},{min:'45',label:'00:45'},{min:'60',label:'1 hour'},{min:'75',label:'1 hour 15 min'},{min:'90',label:'1 hour 30 min'},{min:'105',label:'1 hour 45 min'}]
    }
  },
  // watch: {
  //   date (){
  //     this.meeting.date = this.$moment(this.date).format('YYYY-MM-DD')
  //   },
  //   startTime (){
  //     // Set End time based on duration
  //     this.endTime = this.$moment(this.startTime,'HH:mm').add(parseInt(this.meeting.duration), 'minutes').format('HH:mm')
  //     this.meeting.time = this.startTime
  //   },
  //
  // endTime () {
  //   // If End time <= start time then reset start time based on duration
  //   if (this.$moment(this.endTime,'HH:mm') <= this.$moment(this.startTime,'HH:mm')) {
  //     this.startTime = this.$moment(this.endTime,'HH:mm').subtract(parseInt(this.meeting.duration),'minutes').format('HH:mm')
  //   } else {
  //   // Set duration based on start and end time
  //     this.meeting.duration = this.$moment(this.endTime,'HH:mm').diff(this.$moment(this.startTime,'HH:mm'),'minutes')
  //   }
  //   }
  // },
  computed: {
    attendeeEmailValid () {
      var emailsValid=true
      this.selectedAttendees.forEach((attendee) => {
        if (attendee.email!='' && !this.reg.test(attendee.email)) {
          console.log('email invalid')
          emailsValid = false
        }
      })
      return emailsValid
    },
    filteredItems() {
     return this.attendees.filter(i => {
       if(i.email) {
         return i.email.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1
     }
     })
    },
    dispDuration () {
     var dur = this.$moment()
     dur.seconds(0)
     dur.hours(0)
     dur.minute(parseInt(this.meeting.duration))
     return dur.format('HH:mm')
    },
    meetingNameValid () {
      return this.validationOn ? this.meeting.name !== '' : null
    },
    meetingValid () {
      return this.meetingNameValid
    },
    // startTimes () {
    //   var timeSlots= []
    //   var start = this.$moment()
    //   var end = this.$moment()
    //   start.set({hour:0,minute:0,second:0,millisecond:0})
    //   end.set({hour:0,minute:0,second:0,millisecond:0})
    //   end.add(24,'hours')
    //   timeSlots [0] = start.format('HH:mm')
    //   start.add('15', 'minutes')
    //   timeSlots [1] = start.format('HH:mm')
    //   var i=0
    //   while (start.isBefore(end)) {
    //     start.add('15', 'minutes')
    //     timeSlots[i] = start.format('HH:mm')
    //     i++
    //   }
    //   return timeSlots
    // }
  },
  methods: {
    // updateTime(time){
    //   debugger
    //   alert('updateTime')
    // },
    // selectTime (element) {
    //   const select = this.$refs[element]
    //   let position = select.filteredOptions.indexOf(select.value)
    //   select.pointerSet(position)
    //   this.$nextTick(() => {
    //     select.$refs.list.scrollTop = select.pointerPosition-50
    //   })
    // },
    beforeAddTag (tag) {
      if  (tag.tag.text.indexOf('<') > -1) {
        // Parse email and name
        var parts = tag.tag.text.split('<')
        tag.tag.text = parts[0].trim()
        tag.tag.email = parts[1].substring(0,parts[1].length-1)
      }
      else if (tag.tag.text.indexOf('@') > -1){
        tag.tag.email = tag.tag.text
      }
      if (!this.reg.test(tag.tag.email)) {
        tag.tag.style = 'color: red'
        this.attendeesValid = false
      }
      tag.addTag()
    },
    requestContactsAccess () {
      mixpanel.track('Connect Google Contacts & Calendar')
      this.googleUser.grant(this.googleOptions).then(
          (success) => {
            this.googleContactsConnected = true
            setTimeout(this.getUsers(),2000)
          },
          function(fail){
            console.log(JSON.stringify({message: "fail", value: fail}))
          })
    },
    getUsers () {
        return gapi.client.request({
          'path': '/m8/feeds/contacts/default/full?alt=json&max-results=999',
          'headers': {
            'GData-Version': 3.0
          }
        }).then((response) => {
         var contactsData = JSON.parse(response.body)
         var contact = contactsData.feed.entry.map( (entry) => {
           var email = (entry.gd$email) ? entry.gd$email[0].address: ''
           var dsp = entry.title.$t ? entry.title.$t : email
           return {text:dsp, email: (entry.gd$email) ? entry.gd$email[0].address: ''}
         })
         this.attendees = contact

      }, (reason) => {
        console.log('Error: ' + reason.result.error.message);
      })

         },
    // addTag (newTag) {
    //   const tag = {
    //     name: newTag,
    //     code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
    //   }
    //   this.attendees.push(tag)
    //   this.value.push(tag)
    // },
    cancel () {
      if (this.mode === 'create') {
        router.push({name: 'MyMeetings'})
      } else {
        router.push({name: 'ViewMeeting', query: {id: this.id}})
      }
    },
    saveMeeting () {
      this.validationOn = true
      if (this.meetingValid === false || this.attendeeEmailValid === false) {
        this.formValid = false
        return
      }
      this.meeting.showCalendarUpdate=this.mode
      var mapAttendees = this.selectedAttendees.map((attendee) => {return {name: attendee.text, email:attendee.email}})
      db.collection('Meetings').doc(this.id).set(this.meeting)
        .then(docRef => {
          if (this.mode == 'create'){
            mixpanel.track('Create Meeting', {'date': this.meeting.date})

            // Save Attendees
            var batch = db.batch()
            for ( var i=0; i < mapAttendees.length; i++) {
              mapAttendees[i].status='Not here yet'
              batch.set(db.collection('Meetings').doc(this.id).collection('attendees').doc(),mapAttendees[i])
            }
            batch.commit()
          }

          router.push({name: 'ViewMeeting', query: {id: this.id}})
        })

    }
  },
  mounted: function () {
    const scopes = [
      'https://www.googleapis.com/auth/contacts.readonly',
      'https://www.googleapis.com/auth/calendar'
    ]
    this.$getGapiClient()
      .then(gapi => {
        var options = new gapi.auth2.SigninOptionsBuilder(
          {
            prompt: 'select_account',
            // 'scope': 'https://www.google.com/m8/feeds'}
            'scope':
              'https://www.googleapis.com/auth/contacts.readonly https://www.googleapis.com/auth/calendar'
          })
        this.googleOptions = options
        this.googleUser = gapi.auth2.getAuthInstance().currentUser.get()
        if (this.googleUser.getGrantedScopes() && this.googleUser.getGrantedScopes().includes('https://www.googleapis.com/auth/contacts.readonly')){
          this.getUsers()
        } else {
          this.googleContactsConnected = false
        }
      })

    if (this.$route.params.id !== undefined) {
      this.mode = 'update'
      this.id = this.$route.params.id
      this.$bind('meeting', db.collection('Meetings').doc(this.id)).then(() =>{
        // debugger
        // alert(this.startTime)
        // this.startTime  = this.meeting.time
        this.date = this.$moment(this.meeting.date).toDate()
      })
      this.$bind('agenda', db.collection('Meetings').doc(this.id).collection('agenda'))
      this.$bind('selectedAttendees', db.collection('Meetings').doc(this.id).collection('attendees'))
    } else {
      this.mode = 'create'
      this.id = db.collection('Meetings').doc().id
      this.meeting.time="09:45"
      this.date = this.$moment().add(24, 'hours').toDate()
    }
  },
  components: {
    MeetingTime: MeetingTime
  }
}
</script>
<style >
  #meetingForm {margin: 1rem  3rem}
  .formButtons {width: 32.2rem; display:flex; justify-content: flex-end;}
  /* #selectTime .v-select   */
  .vs__dropdown-toggle{height:2.41rem; Xbackground-color: green !important}
  /* .vs__search {background-color: pink !important} */
  /* #selectAttendees input { height: 5rem} */

  .v-select .dropdown-toggle {
display: flex !important;
flex-wrap: wrap;}

.v-select input[type=search], .v-select input[type=search]:focus {
flex-basis: 20px;
flex-grow: 1;
height: 33px;
padding: 0 20px 0 10px;
width: 100% !important;
}
/* Google contacts Selector  */
.multiselect__tag{background-color: #afadad !important}
.ti-input{width: 32rem; border: 1px #ced4da solid !important; border-radius: 0.25rem !important }
.ti-tag{background-color: #afadad !important}


.tags-input-wrapper-default{min-height:3rem}
.tags-input-remove { color: white !important}
/* .ti-new-tag-inputX {background-color: green !important} */
.ti-new-tag-input-wrapper::before {
  content: "\A"; white-space: pre;
}
/* .ti-new-tag-input-wrapper {flex-basis: 100%} */
.ti-new-tag-input-wrapper {flex-basis: 100% !important}
.ti-tag.email.ti-invalid {color: red}
.vue-tags-input .ti-item.ti-selected-item {
  background-color: #5897fb;
  color: white;
}

/*  Date Selector **/
.vc-border {}
.vc-border-gray-400 {border-color: #ced4da !important; border-radius: 0.25rem !important}

  /* Time Selection */
.multiselect__option--highlight {background: #5897fb !important}
.multiselect__tags {border: 1px solid #ced4da !important;  border-radius: 0.25rem !important;  line-height: 1.25rem; min-height: 1.25rem !important}
</style>
